import styled from "styled-components"

import colors from "styles/colors"
import media from "styles/media"
import text from "styles/text"
import UniversalLink from "utils/Loader/UniversalLink"

import { ReactComponent as ArrowSVG } from "../../images/global/seafoam-arrow.svg"

export default function SeafoamLine({
  children,
  href,
  onClick = () => {},
}: {
  children: React.ReactNode
  onClick?: () => void
  href: string
}) {
  return (
    <LinkEl onClick={onClick}>
      <UniversalLink to={href}>
        {children} <ArrowSVG />
      </UniversalLink>
    </LinkEl>
  )
}

const LinkEl = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${media.fullWidth} {
    margin-bottom: 15px;
  }

  ${media.desktop} {
    margin-bottom: 0.904vw;
  }

  ${media.tablet} {
    margin-bottom: 1.465vw;
  }

  ${media.hover} {
    :hover {
      transition-duration: 0.3s;
      color: ${colors.white};
      a {
        color: ${colors.white};
        transition: 0.3s;
      }
      svg {
        path: {
          fill: ${colors.white};
          transition: fill 0.3s;
        }
      }
    }
  }

  a {
    color: #05e0e0;
    ${text.buttonR}
    text-decoration: none;
    width: 100%;
    display: flex;
    justify-content: space-between;
    transition: 0.3s;
  }

  svg {
    transition: fill 0.3s;
    ${media.fullWidth} {
      width: 15px;
      height: 15px;
    }
    ${media.tablet} {
      width: 1.465vw;
      height: 1.465vw;
    }
    margin-left: auto;
    width: 0.904vw;
    height: 0.904vw;
  }
`
